<template>
    <div class="avatar-container">
        <div class="avatar-image">
             <i class="bx bx-user"></i>
        </div>
        <p class="avatar-name">Sample</p>
    </div>
</template>

<script>
export default {
  name: 'PreviewAvatar',
};
</script>

<style lang="scss" scoped>
.avatar-container {
    display: flex;
    .avatar-image{
        background-color: #8286FF;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        i {
            font-size: 20px;
            color: #fff;
        }
    }
    .avatar-name{
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: 0%;
        text-align: center;
        color: #646A8C;
    }
}
</style>
